// extracted by mini-css-extract-plugin
export default {"header":"subObjectHeader_header__KB8cL"};